import React from "react"
import { Button, ButtonProps } from "@material-ui/core"

interface Props {
  progress: boolean
}

export default function ProgressButton({ progress, children, ...other }: ButtonProps<"button", Props>) {
  return (
    <Button {...other} disabled={progress}>
      {children}
    </Button>
  )
}
